<template>
	<div class="modal-wrapper modal-motivation flex flex-col">
		<div class="motivation-wrapper">
			<div class="motivation-loader-wrapper">
				<div class="loader-text">
					{{ $tc('modals.motivationModal.loading') }}...
				</div>
				<loader :total-steps="5" :step="loaderStep" />
			</div>
			<div class="quote-wrapper flex flex-col justify-center">
				<div class="motivation-text">
					“{{ motivationQuote.text }}”
				</div>
				<div class="motivation-author">
					{{ motivationQuote.author }}
				</div>
				<div class="motivation-position">
					{{ motivationQuote.position }}
				</div>
				<div v-if="motivationQuote.logo" class="motivation-logo">
					<img :src="`/my/images/wizard/clubs/${motivationQuote.logo}`" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'
import content from '~/static/wizard-content/StepMotivation.json'
import Loader from '~/components/wizard-new/common/Loader.vue'

export default {
	name: 'ModalWizardMotivation',
	components: {
		Loader
	},
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			content: content.quotes,
			loaderStep: 0
		}
	},
	computed: {
		motivationQuote () {
			const quotesList = ['coach', 'parent', 'scout'].includes(this.options.role)
				? this.content.filter(item => item.roles.includes(this.options.role))
				: this.content.filter(item => item.roles.includes('all'))
			return quotesList[Math.floor(Math.random() * quotesList.length)]
		}
	},
	created () {
		const intervalId = setInterval(() => {
			if (this.loaderStep === 5) {
				clearInterval(intervalId)
				this.onClose()
			}
			this.loaderStep++
		}, 1000)
	}
}
</script>

<style lang="scss">
.modal-motivation {
	background: linear-gradient(90.01deg, #3D3C90 1.19%, #7E008D 100.25%);
	height: 100vh;
	justify-content: center;
	align-items: center;
	@include respond-below(phone) {
		justify-content: flex-start;
		padding-top: 45px;
	}
}
.motivation {
	&-loader-wrapper {
		background-color: #FFFFFF;
		padding: 32px 32px 38px;
		border-radius: 20px;
		margin-bottom: 21px;
		@include respond-below(phone) {
			margin-bottom: 18px;
		}
		.loader-text {
			font-size: 20px;
			color: #2B2B2B;
			margin-bottom: 11px;
		}
	}
	&-wrapper {
		width: 90%;
		max-width: 482px;
		.quote-wrapper {
			background: #FFFFFF;
			border-radius: 20px;
			padding: 24px 26px 29px 32px;
			transition: all .2s ease;
			margin: auto;
			color: #2B2B2B;
			> div {
				transition: all .2s ease;
			}
		}
	}
	&-text {
		font-size: 24px;
		line-height: 28px;
		font-weight: 500;
		margin-bottom: 19px;
	}
	&-author {
		font-size: 20px;
		line-height: 24px;
		margin-bottom: 8px;
	}
	&-position {
		font-size: 16px;
		line-height: 20px;
		color: #8A8B9F;
		margin-bottom: 19px;
		padding-right: 20%;
		@include respond-below(phone) {
			padding-right: 0;
		}
	}
	&-logo {
		img {
			height: 92px;
			vertical-align: top;
		}
	}
}
</style>
